/* eslint-disable react-hooks/rules-of-hooks */

import { AxiosError } from "axios";
import { useRouter } from "next/navigation";
import { useDispatch } from "react-redux";

import axioInstance from "@/libs/axios";
import { useRenewalPaymentSummaryStateContext } from "@/providers/renewal-payment-summary-auto-pay-state-provider";
import { QuoteData } from "@/types/quote/quote-data";
import handleError, { ErrorResponse } from "@/utils/handle-errors";

export const usesaveConsent = ({
  version,
  type,
  attributes,
  referenceId,
}: {
  version: string | undefined;
  type: string;
  attributes: QuoteData["attributes"];
  referenceId: string | undefined;
}) => {
  const dispatch = useDispatch();
  const router = useRouter();

  const { setIsOpenCardholderConsentModal, isCardHolder, isFuturePayment } =
    useRenewalPaymentSummaryStateContext();
  const saveConsent: () => Promise<boolean> = async () => {
    if (version) {
      try {
        const requestBody = {
          type,
          channel: "OFFLINE",
          version,
          attributes: {
            domain: attributes.domain,
            paymentDetails: {
              cardHolderConsent: {
                isCardHolder,
                isFuturePayment,
              },
            },
          },
        };
        const config = {
          data: requestBody,
        };
        await axioInstance.patch(
          `/quote/${referenceId}/updateCardHolderConsent`,
          config
        );

        return true;
      } catch (error) {
        const axiosError = error as AxiosError;
        handleError(axiosError as AxiosError<ErrorResponse>, router, dispatch);
        return false;
      } finally {
        setIsOpenCardholderConsentModal(false);
      }
    } else {
      setIsOpenCardholderConsentModal(false);
      return false;
    }
  };

  return [saveConsent];
};
